const MuiTableContainer = {
  root: {
    overflow: 'auto'
  }
};

export default MuiTableContainer;
